import type { FunctionComponent } from 'react';
import { ProductHome } from '@atlaskit/atlassian-navigation';
import { TrelloLogo } from '@atlaskit/logo';

const BlueTrelloLogo = () => {
  return <TrelloLogo appearance="brand" />;
};

const TrelloLogoComponent: FunctionComponent = () => {
  return <ProductHome icon={BlueTrelloLogo} logo={BlueTrelloLogo} />;
};

export default TrelloLogoComponent;
